module.exports = __webpack_public_path__ + "static/media/SinPinLogo.29b25ae9.png";